import Vue from 'vue';

// Domain
import {
  CreateInvestorGoalStateManager,
} from '@/modules/flagship/investor-goal/investor_goal/domain/state/create-investor-goal-state-manager';
import CreateInvestorGoalState
  from '@/modules/flagship/investor-goal/investor_goal/domain/state/create-investor-goal-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
class CreateInvestorGoalVueStateManager implements CreateInvestorGoalStateManager {
  private _state: CreateInvestorGoalState = Vue.observable<CreateInvestorGoalState>(
    new CreateInvestorGoalState(),
  );

  private readonly observers: Observer[] = [];

  get state(): CreateInvestorGoalState {
    return this._state;
  }

  set state(value: CreateInvestorGoalState) {
    this._state = value;
  }

  patch(state: Partial<CreateInvestorGoalState>) {
    type Keys = keyof CreateInvestorGoalState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}

export default CreateInvestorGoalVueStateManager;
